module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/Checked-c8ddc502f5b82da1e4cdf86d2a4ce9b9.svg";